<!-- Transparent loading spinner -->
@if (!disableSpinner) {
  <ngx-spinner
    name="spinner-soft"
    [zIndex]="999999"
    color="#000000"
    bdColor="rgba(0,0,0,0)"
    type="null"
  ></ngx-spinner>
}

<!-- Loading spinner -->
@if (!disableSpinner) {
  <ngx-spinner
    name="spinner-hard"
    [zIndex]="999999"
    bdColor="rgba(51,51,51,0.8)"
    color="#FFFFFF"
    type="cog"
  >
    <h5 [ngClass]="{ 'spinner-text': !hideDesktopMenus && gameActive && !showGame }">
      <i>{{ spinnerText ? spinnerText : ("loading-data" | translate) }}</i>
    </h5>
    @if (spinnerHasError) {
      <div class="spinner-error-actions">
        <button class="spinner-action-btn spinner-action-btn--reload" (click)="reloadPage()">
          <i class="fas fa-sync-alt"></i>
          {{ "spinner-reload" | translate }}
        </button>
        <button class="spinner-action-btn" (click)="dismissSpinnerError()">
          {{ "spinner-dismiss" | translate }}
        </button>
      </div>
    }
    @if (!spinnerHasError && !hideDesktopMenus && gameActive && sessionProfile == PROFILES.ARSON) {
      <div class="loading-screen-game">
        @if (!showGame) {
          <div class="spinner-game-advise">
            {{ "spinner-game-advise" | translate }}
            <button (click)="showGame = true">
              {{ "spinner-game-play" | translate }}
            </button>
          </div>
        }
        @if (showGame) {
          <app-snake></app-snake>
        }
      </div>
    }
  </ngx-spinner>
}

<!-- Loading spinner -->
<ng-template #elseBlock>
  <div class="loading-spinner">
    <i class="fas fa-spinner fa-pulse"></i>
  </div>
</ng-template>

<div class="wrapper" (dragover)="enableDrop ? $event.preventDefault() : null">
  <!-- Top navigation bar -->
  @if (sessionProfile != PROFILES.ABONADO) {
    <app-navbar-top
      [loadSession]="loadSession"
      [hideDesktopMenus]="hideDesktopMenus"
      [profileStartUrl]="profileStartUrl"
      (logoutFlag)="logout()"
      (logoImgUrlUpdate)="logoImgUrlUpdate($event)"
    ></app-navbar-top>
  }

  <!-- Side navigation bar -->
  @if (
    sessionProfile != PROFILES.ABONADO && sessionProfile != PROFILES.INSTALADOR && !hideDesktopMenus
  ) {
    <app-navbar-side
      [logoImgUrl]="logoImgUrl"
      (sidebarUpdate)="sidebarLocked = $event; SessionDataService.sendSidebarLocked(sidebarLocked)"
    ></app-navbar-side>
  }

  <!-- Subscriber navigation bar -->
  @if (sessionProfile == PROFILES.ABONADO) {
    <app-subscriber-nav (logoutFlag)="logout()"></app-subscriber-nav>
  }

  <!-- Task progress -->
  @if (sessionProfile != PROFILES.ABONADO && sessionProfile != PROFILES.INSTALADOR) {
    <app-request-progress-panel></app-request-progress-panel>
  }

  <!-- Contenedor -->
  <div
    [ngClass]="{
      'dashboard-container': sessionProfile != PROFILES.ABONADO,
      'installer-dashboard-container': sessionProfile == PROFILES.INSTALADOR,
      'subscriber-dashboard-container': sessionProfile == PROFILES.ABONADO,
      'dashboard-container-toggled': sidebarLocked,
      'center-block': !manufacturerDataReady
    }"
  >
    @if (manufacturerDataReady) {
      <router-outlet #outlet="outlet"></router-outlet>
    } @else {
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-pulse"></i>
      </div>
    }
  </div>

  <!-- ANCHOR: Chatbot (ARSON only) -->
  @if (chatbotEnabled) {
    <app-chatbot></app-chatbot>
  }

  <!-- Footer -->
  <app-footerbar
    [subscriberFooter]="sessionProfile == PROFILES.ABONADO"
    [sessionProfile]="sessionProfile"
    [appVersion]="appVersion"
    [sidebarLocked]="sidebarLocked"
  ></app-footerbar>
</div>
